import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { ChangeEmail } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class ChangeEmailModal extends Component {
  static propTypes = {
    modalId: PropTypes.string
  }

  render() {
    const { modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title={
          <FormattedMessage
            id="title.change_email"
            defaultMessage="Change email"
          />
        }
      >
        <MaterialModal.Content>
          <ChangeEmail {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
